import React, { useEffect, useState } from "react";
import "../../style/user/Profile.css";
import { getMyProfile } from "../../types/authService";

interface UserProfile {
  firstName: string;
  middleName?: string;
  lastName: string;
  role: string;
  mobileNumber: string;
}

const MyProfile: React.FC = () => {
  const userName = localStorage.getItem("userName") || "";
  const [user, setUser] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userName) {
      getMyProfileData(userName);
    }
  }, [userName]);

  const getMyProfileData = async (userName: string) => {
    try {
      const data = await getMyProfile(userName);
      setUser(data);
    } catch (err) {
      console.error("Failed to load profile", err);
    } finally {
      setLoading(false);
    }
  };

  // ⛔ STOP rendering until safe
  if (loading) {
    return <div className="profile-container">Loading profile...</div>;
  }

  if (!user) {
    return <div className="profile-container">Profile not found</div>;
  }

  return (
    <div className="profile-container">
      <h2>My Profile</h2>

      <div className="profile-card">
        <div className="profile-row">
          <label><b>Username:</b></label>
          <span>{userName}</span>
        </div>

        <div className="profile-row">
          <label><b>First Name:</b></label>
          <span>{user.firstName}</span>
        </div>

        <div className="profile-row">
          <label><b>Middle Name:</b></label>
          <span>{user.middleName ?? "-"}</span>
        </div>

        <div className="profile-row">
          <label><b>Last Name:</b></label>
          <span>{user.lastName}</span>
        </div>

        <div className="profile-row">
          <label><b>Role:</b></label>
          <span>{user.role}</span>
        </div>

        <div className="profile-row">
          <label><b>Mobile:</b></label>
          <span>{user.mobileNumber}</span>
        </div>

        <div className="profile-row">
          <label><b>Status:</b></label>
          <span className="active">Active</span>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
